import React from 'react';
import PropTypes from 'prop-types';
import styles from './player.scss';
import logo from '#/static/images/icons/skiddle.svg';
import { videoAnalytics } from '#/config/constants';

const VideoInterrupted = ({ interruptionReason, onRetry }) => {
  const isNetworkIssue =
    interruptionReason === videoAnalytics.events.NETWORK_ERROR ||
    (typeof navigator !== 'undefined' && navigator.onLine === false);

  return (
    <div style={{ display: 'block !important', width: '100%', height: '100%' }}>
      <img alt="logo" src={logo} className={styles.sensicalLogo} />
      <div className={styles.playerInterrupted}>
        <h1>
          {isNetworkIssue
            ? 'Network connection lost during playback.'
            : 'Oops, something went wrong with playback.'}
        </h1>
        <h2>
          {isNetworkIssue
            ? 'Please reconnect to the internet and retry playback.'
            : 'Please hit back and select a new video or try again later.'}
        </h2>
        {isNetworkIssue && (
          <button type="button" onClick={onRetry}>
            Retry Playback
          </button>
        )}
      </div>
    </div>
  );
};

VideoInterrupted.propTypes = {
  interruptionReason: PropTypes.string,
  onRetry: PropTypes.func,
};

export default VideoInterrupted;
